import { parseNodeData } from '../../js/graphql/utils'
import { buildArticlePermalink } from '../../js/utils/urls'

export function buildPostParams(data, padded = true) {
  if (!data) {
    return {}
  }

  const { page } = data
  const {
    slug,
    year,
    month,
    day,
  } = parseNodeData(data)

  return {
    ...data,
    year,
    month,
    day,
    params: {
      year: year.toString(),
      month: month.toString().padStart(2, '0'),
      day: padded ? day.toString().padStart(2, '0') : day.toString(),
      slug: decodeURIComponent(data.slug),
      ...(page ? { page: page.toString() } : {}),
    },
    href: buildArticlePermalink({
      year,
      month,
      day,
      slug,
      page,
    }),
  }
}
